import React, { useEffect, useId, useState } from 'react';
import { Clock3, CalendarDays, Repeat, Star, User } from 'lucide-react';
import BottomNavigationCustomer from './BottomNavigatonCustomer';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../../Assets/navbar/logo.svg';
import axios from 'axios';
import DriverStatusTracking from '../VendorResponsesCustomer/DriverStatusTracking';
import HistoryDetails from '../VendorResponsesCustomer/HistoryDetails';
import CancelledOrders from '../VendorResponsesCustomer/CancelledOrders';

const upcomingTrips = [];

const pastTrips = [
    {
        id: 1,
        title: "Crane Service",
        date: "19 May",
        time: "10:06 am",
        amount: "₹20647.66",
        vehicleNo: 'HR26BN5577',
        mapImg: "https://maps.olakrutrim.com/images/features/routing.svg",
        showRate: true,
        showRebook: true,
        cancelled: false,
    },
    {
        id: 2,
        title: "Crane Service",
        date: "14 May",
        time: "6:23 pm",
        amount: "₹0.00",
        cancelled: true,
        image: "https://www.ace-cranes.com/images/productimage/168993867620230721.png",
    },
    {
        id: 3,
        title: "Crane Service",
        date: "8 May",
        time: "9:58 am",
        amount: "₹0.00",
        cancelled: true,
        image: "https://www.ace-cranes.com/images/productimage/168993867620230721.png",
    },
    {
        id: 4,
        title: "Recovery Van Service",
        date: "30 Apr",
        time: "10:27 pm",
        amount: "₹16009.29",
        image: "https://cpimg.tistatic.com/10302746/b/4/extra-10302746.jpeg",
    },
];

const ActivityPage = () => {
    const [selectedFilter, setSelectedFilter] = useState('completed');
    console.log('selected', selectedFilter)
    const filteredTrips = pastTrips.filter((trip) =>
        selectedFilter === 'completed' ? !trip.cancelled : trip.cancelled
    );

    const [currentService, setCurrentService] = useState('recoveryVan')

    useEffect(() => {
        localStorage.setItem('currentService', currentService)
    }, [currentService]);


    return (

        <div className="font-satoshi mb-3 ">

            {/* <div className="fixed top-0 left-0 w-full justify-between px-4 py-2 z-50 bg-[#f5f5f5]">
            <div className="absolute top-0 left-0 w-full h-1/2 bg-gradient-to-b from-[#38bdff] to-transparent z-0"></div>
                <img src={logo} alt="logo" className="h-[3rem] w-[3rem] bg-[#ffffffc4] rounded-full  p-1" />
                <h1 className="text-2xl mt-[1rem] font-bold ">Your Updates</h1>
            </div> */}
             <div className="nav fixed top-0">
        <div  className="logo rounded-full">
            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/logo-navbar-compressed.png'/>
        </div>
       
    </div>

            <div className='banner mt-[4rem]'>
                <div className='banner-overlay'>

                    <h3>Your Updates</h3>
                </div>
            </div>
            <div  className='update-container'>



                <section>
                    <DriverStatusTracking />
                </section>

                {/* Past Section */}

                <div className="flex justify-start mb-4 gap-2">
                    <button onClick={() => setCurrentService('recoveryVan')} className={`px-2 py-2  rounded-md text-sm  font-semibold   ${currentService === 'recoveryVan' ? 'bg-blue-300 text-gray-700' : 'bg-white text-gray-700'}`}>Recovery Van</button>
                    <button onClick={() => setCurrentService('crane')} className={`px-2 py-2  rounded-md text-sm font-semibold  ${currentService === 'crane' ? 'bg-blue-600 text-white' : 'bg-white text-gray-700'} `}>Crane</button>
                </div>

                <div className="flex justify-start mb-4 gap-2">
                    <button onClick={() => setSelectedFilter('completed')} className={`px-2 py-2  rounded-md text-sm font-semibold  ${selectedFilter === 'completed' ? 'bg-blue-600 text-white' : 'bg-white text-gray-700'} `}>Request completed</button>
                    <button onClick={() => setSelectedFilter('cancelled')} className={`px-2 py-2  rounded-md text-sm  font-semibold   ${selectedFilter === 'cancelled' ? 'bg-red-600 text-white' : 'bg-white text-gray-700'}`}>Request cancelled</button>
                </div>
                <section>

                    {selectedFilter == 'completed' && (
                        <div>
                            <HistoryDetails currentService={currentService} />
                        </div>
                    )}
                    {selectedFilter == 'cancelled' && (
                        <CancelledOrders currentService={currentService} />
                    )}
                </section>



            </div>

            <BottomNavigationCustomer />
        </div>
    );
};

export default ActivityPage;
